export const myDetailsDropDown = [
  {
    title: "profile",
    url: "/view-profile/v2",
  },
  {
    title: "myOrders",
    url: "/my-order/v2",
  },
  {
    title: "wishlist",
    url: "/my-wishlist/v2",
  },
  // {
  //   title: 'Payments',
  //   url: '/my-payments'
  // },
  // {
  //   title: 'wallet',
  //   url: '/my-wallet'
  // },
  {
    title: "addresses",
    url: "/my-addresses/v2",
  },
  {
    title: "Wallet",
    url: "/my-wallet/v2",
  },
  {
    title: "notifications",
    url: "/notifications",
  },
  // {
  //   title: "logout",
  //   url: "/logout",
  // },
  // {
  //   title: "deleteAccount",
  //   url: "/logout",
  // },
];
